import L from "leaflet"

const GridBackgroundLayer = L.GridLayer.extend({
    createTile: function(coords) {
		if (!Number.isFinite(this._pixelRatio)) {
			this._pixelRatio = window.devicePixelRatio;
		}

		const tile = L.DomUtil.create('canvas', 'leaflet-tile');

		const size = this.getTileSize();
        tile.width = size.x * this._pixelRatio;
        tile.height = size.y * this._pixelRatio;

		const g = tile.getContext("2d");
		const pixelCoords = tileCoordsToPixelCoors(coords, size);
		renderBackgroundGrid(g, pixelCoords[0], pixelCoords[1], size, pixelCoords[2], this._pixelRatio);

		return tile;
	}
});

function renderBackgroundGrid(g, leftX, topY, tileSize, tileSpan, renderingPixelRatio) {
	// const hspan = tileSpan/2;
	/*
	g.fillStyle = "#000";
	g.fillRect(0, 0, 8, 1);
	g.fillRect(0, 0, 1, 8);
	g.fillText(`${leftX}, ${topY}`, 4, 14);
*/
	g.save();
	g.textAlign = "center";
	g.textBaseline = "middle";
	g.font = `normal ${ 9*renderingPixelRatio }px sans-serif`;

	const labelXMargin = 90 * renderingPixelRatio;
	const labelYMargin = 30 * renderingPixelRatio;
	const canvasW = tileSize.x * renderingPixelRatio;
	const canvasH = tileSize.y * renderingPixelRatio;

	const pr = tileSize.x / tileSpan;
	for (let phase = 0;phase < 2;++phase) {
		const scaleInterval = (!phase) ? 10 : 100;
		const needsLabel = (!!phase);
		g.fillStyle = (!phase) ? "#bbb" : "#777";

		iterateScalePositios(leftX, scaleInterval, tileSize, tileSpan, 16, (scaleX, nInTile) => {
			const drawX = (scaleX - leftX) * pr * renderingPixelRatio;
			const lineWidth = ((0 === scaleX) ? 2 : 1) * renderingPixelRatio;
			g.fillRect(drawX - lineWidth/2, 0, lineWidth, canvasH);
			if (needsLabel && nInTile < 4 && scaleX !== 0) {
				for (let li = 0;li < 2;++li) {
					const zy = calcLabelPosition(topY, canvasH, tileSpan, scaleInterval, !!li);
					if (zy >= -labelYMargin && zy < (canvasH+labelYMargin)) {
						clear_and_draw_label(g, drawX, zy, `${scaleX}m`, renderingPixelRatio);
					}
				}
			}
		});

		iterateScalePositios(topY, scaleInterval, tileSize, tileSpan, 16, (scaleY, nInTile) => {
			const drawY = (scaleY - topY) * pr * renderingPixelRatio;
			const lineWidth = ((0 === scaleY) ? 2 : 1) * renderingPixelRatio;
			g.fillRect(0, drawY - lineWidth/2, canvasW, lineWidth);
			if (needsLabel && nInTile < 4 && scaleY !== 0) {
				for (let li = 0;li < 2;++li) {
					const zx = calcLabelPosition(leftX, canvasW, tileSpan, scaleInterval, !!li);
					if (zx >= -labelXMargin && zx < (canvasW + labelXMargin)) {
						clear_and_draw_label(g, zx, drawY, `${scaleY}m`, renderingPixelRatio);
					}
				}
			}
		});
	}

	g.restore();
}

function clear_and_draw_label(g, x, y, text, renderingPixelRatio) {
	const mt = g.measureText(text);
	const tW = mt.width/2 + 5*renderingPixelRatio;

	const ch = 8*renderingPixelRatio;
	g.clearRect(x-tW, y-ch, tW*2, ch*2);
	g.fillText(text, x, y);
}

function calcLabelPosition(tileStartCoord, visibleTileLength, tileSpan, scaleInterval, higher) {
	const pos = (scaleInterval/2) * (higher ? 1 : -1);
	const pr = visibleTileLength / tileSpan;
	return (pos - tileStartCoord) * pr;
}

function iterateScalePositios(tileStartCoord, scaleSpan, tileSize, tileSpan, limit, callback) {
	const n = Math.floor(tileSpan / scaleSpan);
	// 表示する本数を制限
	if (n >= limit) { return; }

	const start = Math.floor(tileStartCoord / scaleSpan) * scaleSpan;
	for (let i = 0;i <= (n+1);++i) {
		const scaleValue = start + i*scaleSpan;
		callback(scaleValue, n+1);
	}
}

function tileCoordsToPixelCoors(tileCoords, tileSize) {
	const scale = tileSize.x / Math.pow(2, tileCoords.z);
	return [tileCoords.x * scale, tileCoords.y * scale, scale];
}

export { GridBackgroundLayer };